import { isoCodeToEmojiFlag } from './formatting';
import Modal from './packages/Modal';
export const showConfirmPhoneNumberModal = ({ countryCode, prefix, phoneNumber, onSendCode, onEditNumber, }) => {
    Modal.showConfirmation({
        title: `${isoCodeToEmojiFlag(countryCode)} ${prefix} ${phoneNumber}`,
        subtitle: 'Is this number correct? We’ll send a verification code to this number',
        confirmButtonTitle: 'Edit number',
        onConfirm: onEditNumber,
        cancelButtonTitle: 'Send code',
        onPressCancel: onSendCode,
    });
};
export default showConfirmPhoneNumberModal;
